import {nvText, locale, timeZone} from './nuvia-i18n.js';
import { CartLinesUpdateEvent } from '@shopify/events';

// Latvian offers use Shopify Bundles so gifts remain attached through checkout.
const LATVIA_GIFT_BUNDLES = { 3: 54913010434381, 5: 54913080131917 };
let giftProductData = null;
const GIFT_CSS = "/* Gift rows share the selected card colour, including the Hebrew RTL layout. */\n.nv-pack--with-gifts .nv-pack-gifts{grid-column:1/-1;display:block;align-self:end;margin:0 -12px -8px;border-radius:0 0 3px 3px;background:#e3eee7;color:#16462f;overflow:hidden}\n.nv-pack--with-gifts:has(input:checked) .nv-pack-gifts{background:#528469;color:#fff;margin:0 -11px -7px}\n.nv-pack-gifts .nv-gift-row{display:grid;grid-template-columns:42px minmax(0,1fr) auto;align-items:center;gap:10px;padding:10px 12px;text-align:start}\n.nv-pack-gifts .nv-gift-row+.nv-gift-row{border-top:1px solid rgba(255,255,255,.5)}\n.nv-pack-gifts .nv-gift-row img{width:42px;height:42px;aspect-ratio:1;object-fit:cover;border-radius:6px;background:#f4faf6;display:block}\n.nv-pack-gifts .nv-gift-copy{font-size:12px;font-weight:600;line-height:1.35;min-width:0}\n.nv-pack-gifts .nv-gift-price{display:flex;flex-direction:column;gap:3px;align-items:flex-end;white-space:nowrap;font-size:11px;line-height:1.2}\n.nv-pack-gifts .nv-gift-price s{color:inherit;opacity:.8;font-size:11px;line-height:1.2;margin:0}\n.nv-pack-gifts .nv-gift-price b{font-size:10px;letter-spacing:.03em;line-height:1.2}\n.nv-buy--home .nv-pack--with-gifts .nv-pack-gifts{width:calc(100% + 24px);margin:12px -12px -12px;border-radius:0 0 10px 10px}\n@media(max-width:749px){\n .nv-pack--with-gifts .nv-pack-gifts{margin:0 -10px -10px}\n .nv-pack--with-gifts:has(input:checked) .nv-pack-gifts{margin:0 -9px -9px}\n .nv-pack-gifts .nv-gift-row{grid-template-columns:34px minmax(0,1fr) auto;gap:7px;padding:9px 10px}\n .nv-pack-gifts .nv-gift-row img{width:34px;height:34px}\n .nv-pack-gifts .nv-gift-copy{font-size:11px}\n}\n\n.nv-buy--home .nv-pack.nv-pack--with-gifts .nv-pack-gifts{width:calc(100% + 20px);margin:12px -10px -17px;border-radius:0 0 10px 10px}\n.nv-buy--home .nv-pack.nv-pack--with-gifts:has(input:checked) .nv-pack-gifts{width:calc(100% + 18px);margin:12px -9px -16px}\n.nv-buy--home .nv-pack-gifts .nv-gift-row{grid-template-columns:30px minmax(0,1fr);gap:4px 6px;padding:9px 7px}\n.nv-buy--home .nv-pack-gifts .nv-gift-row img{width:30px;height:30px;grid-row:1/3}\n.nv-buy--home .nv-pack-gifts .nv-gift-copy{font-size:10px;line-height:1.35;overflow-wrap:anywhere}\n.nv-buy--home .nv-pack-gifts .nv-gift-price{grid-column:2;flex-direction:row;flex-wrap:wrap;gap:4px;align-items:center}\n.nv-buy--home .nv-pack-gifts .nv-gift-price s,.nv-buy--home .nv-pack-gifts .nv-gift-price b{font-size:9px}\n";
const giftLabels = {
  lv: { free: 'DĀVANĀ', ebook: 'E-grāmata «Jūsu Nuvia rituāls»', brush: 'Sejas limfodrenāžas birste' },
  et: { free: 'TASUTA', ebook: 'E-raamat „Sinu Nuvia rituaal“', brush: 'Näo lümfimassaaži hari' },
  he: { free: 'במתנה', ebook: 'הספר הדיגיטלי ״טקס הנוביה שלך״', brush: 'מברשת לעיסוי לימפטי לפנים' }
};

async function prepareGiftOffers(box) {
  if (document.documentElement.lang.split('-')[0] !== 'lv') return;
  if (!box.querySelector('[data-nv-variant][value="54832048472397"]')) return;
  const root = window.Shopify?.routes?.root || '/';
  if (!giftProductData) giftProductData = Promise.all([
    'nuvia-jusu-nuvia-rituals-e-gramata', 'nuvia-sejas-masazas-birste'
  ].map(async handle => {
    const response = await fetch(root + 'products/' + handle + '.js');
    if (!response.ok) throw new Error('Gift product unavailable');
    return response.json();
  })).catch(() => { giftProductData = null; return null; });
  const products = await giftProductData;
  if (!products || !box.isConnected) return;
  const config = { ebook: { image: products[0].featured_image, price: products[0].price }, brush: { image: products[1].featured_image, price: products[1].price } };
  if (!document.getElementById('nuvia-gift-styles')) {
    const style = document.createElement('style');
    style.id = 'nuvia-gift-styles'; style.textContent = GIFT_CSS;
    document.head.append(style);
  }
  const lang = document.documentElement.lang.split('-')[0];
  const labels = giftLabels[lang] || giftLabels.lv;
  box.querySelectorAll('[data-nv-variant]').forEach(radio => {
    if (String(radio.value) !== '54832048472397') return;
    const size = Number(radio.dataset.nvQuantity);
    if (size !== 3 && size !== 5) return;
    const card = radio.closest('.nv-pack');
    if (!card) return;
    card.classList.add('nv-pack--with-gifts');
    card.querySelector('.nv-pack-gifts')?.remove();
    const group = document.createElement('span');
    group.className = 'nv-pack-gifts';
    const kinds = size === 5 ? ['ebook', 'brush'] : ['ebook'];
    kinds.forEach(kind => {
      const gift = config[kind];
      if (!gift?.image) return;
      const row = document.createElement('span');
      row.className = 'nv-gift-row';
      const photo = document.createElement('img');
      photo.src = gift.image; photo.alt = ''; photo.width = 48; photo.height = 48;
      photo.loading = 'lazy';
      const copy = document.createElement('span');
      copy.className = 'nv-gift-copy'; copy.textContent = '+ ' + labels[kind];
      const price = document.createElement('span');
      price.className = 'nv-gift-price';
      const before = document.createElement('s');
      before.dir = 'auto'; before.textContent = box.money(gift.price);
      const free = document.createElement('b');
      free.textContent = labels.free;
      price.append(before, free); row.append(photo, copy, price); group.append(row);
    });
    card.append(group);
  });
}

/** @typedef {{id:number, price:number, available:boolean}} NuviaVariant */

class NuviaBuyBox extends HTMLElement {
  /** @type {{variants:NuviaVariant[]}} */
  productData = { variants: [] };
  controller = new AbortController();
  busy = false;

  connectedCallback() {
    this.controller.abort();
    this.controller = new AbortController();
    const data = this.querySelector('[data-nv-product-data]');
    try { this.productData = JSON.parse(data?.textContent || '{"variants":[]}'); } catch { this.productData = { variants: [] }; }
    this.prepareQuantityOffers();
    void prepareGiftOffers(this);
    this.addEventListener('change', this.onChange, { signal: this.controller.signal });
    this.querySelector('form')?.addEventListener('submit', this.onSubmit, { signal: this.controller.signal });
    this.updatePrice();
  }

  disconnectedCallback() { this.controller.abort(); }

  // A single Shopify unit variant uses the store's automatic 2+1 and 3+2 discounts.
  // Existing pre-priced bundle variants keep their original behaviour.
  prepareQuantityOffers() {
    const unit = this.productData.variants[0];
    const source = this.querySelector('.nv-pack');
    if (this.productData.variants.length !== 1 || !unit || String(unit.id) !== '54832048472397' || !source || this.querySelectorAll('[data-nv-variant]').length !== 1) return;
    const isHome = !!this.closest('.nv-buy--home');
    const offers = [
      { quantity: 1, paid: 1, title: nvText('p_d12791344ed8'), badge: '' },
      { quantity: 3, paid: 2, title: nvText('p_50b655b74fe8'), badge: isHome ? nvText('p_f0b3046fbd57') : nvText('p_3bf63694354d') },
      { quantity: 5, paid: 3, title: nvText('p_640406e31d50'), badge: isHome ? '' : nvText('p_222ee109f9f0') }
    ];
    const cards = offers.map(offer => {
      const card = /** @type {HTMLElement} */ (source.cloneNode(true));
      const radio = /** @type {HTMLInputElement} */ (card.querySelector('[data-nv-variant]'));
      radio.value = String(unit.id);
      radio.dataset.nvQuantity = String(offer.quantity);
      radio.dataset.nvPaid = String(offer.paid);
      radio.dataset.price = String(unit.price * offer.paid);
      radio.dataset.compare = String(unit.price * offer.quantity);
      radio.checked = offer.quantity === 3;
      const mini = card.querySelector('.nv-pack-mini');
      const bottle = mini?.querySelector('img');
      if (mini && bottle) mini.replaceChildren(...Array.from({ length: offer.quantity }, () => bottle.cloneNode(true)));
      const title = mini?.nextElementSibling?.querySelector('strong');
      const description = mini?.nextElementSibling?.querySelector('small');
      if (title) title.textContent = offer.title;
      if (description) description.textContent = `${offer.quantity} × 59 ${locale === "he-IL" ? "מ״ל" : "ml"}${unit.available ? '' : nvText('p_f084f34a8868')}`;
      const prices = card.querySelector('.nv-pack-prices');
      prices?.querySelector('s')?.remove();
      if (offer.quantity > 1 && prices) {
        const compare = document.createElement('s');
        compare.textContent = this.money(unit.price * offer.quantity);
        if (!isHome) {
          const reduction = Math.floor(((offer.quantity - offer.paid) / offer.quantity * 100 + 0.000001) / 5) * 5;
          const saving = document.createElement('span');
          saving.className = 'nv-pack-saving';
          saving.textContent = '-' + reduction + '%';
          saving.style.cssText = 'display:inline-block;background:none;color:#41866a;border:0;padding:0;font-size:11px;font-weight:500;line-height:1.2;white-space:nowrap';
          const comparison = document.createElement('span');
          comparison.className = 'nv-pack-comparison';
          comparison.style.cssText = 'display:flex;align-items:center;justify-content:flex-end;gap:5px;flex-wrap:wrap';
          comparison.append(saving, compare);
          prices.append(comparison);
        } else {
          prices.append(compare);
        }
      }
      card.querySelector('.nv-pack-badge')?.remove();
      if (offer.badge) {
        const badge = document.createElement('span');
        badge.className = 'nv-pack-badge'; badge.textContent = offer.badge; card.append(badge);
      }
      return card;
    });
    source.replaceWith(...cards);
  }

  get selectedOffer() {
    return /** @type {HTMLInputElement|null} */ (this.querySelector('[data-nv-variant]:checked'));
  }

  get quantity() { return Number(this.selectedOffer?.dataset.nvQuantity) || 1; }
  get paidQuantity() { return Number(this.selectedOffer?.dataset.nvPaid) || 1; }

  get variant() {
    const radio = /** @type {HTMLInputElement|null} */ (this.querySelector('[data-nv-variant]:checked'));
    return this.productData.variants.find(v => String(v.id) === radio?.value);
  }

  /** @param {number} cents */
  money(cents) {
    const currency = /^[A-Z]{3}$/.test(this.dataset.currency || '') ? this.dataset.currency : 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  /** @param {Event} event */
  onChange = event => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
    this.updatePrice();
  };

  updatePrice() {
    const variant = this.variant;
    const price = variant ? variant.price * this.paidQuantity : undefined;
    this.querySelectorAll('[data-nv-variant]').forEach(radio => {
      if (!(radio instanceof HTMLInputElement)) return;
      const pack = this.productData.variants.find(v => String(v.id) === radio.value);
      const packPrice = radio.closest('.nv-pack')?.querySelector('[data-nv-pack-price]');
      if (pack && packPrice) packPrice.textContent = this.money(pack.price * (Number(radio.dataset.nvPaid) || 1));
    });
    const comparePrice = Number(this.selectedOffer?.dataset.compare) || 0;
    this.querySelectorAll('[data-nv-compare]').forEach(element => {
      if (!(element instanceof HTMLElement)) return;
      element.hidden = price === undefined || comparePrice <= price;
      element.textContent = element.hidden ? '' : this.money(comparePrice);
    });
    const quantityInput = /** @type {HTMLInputElement|null} */ (this.querySelector('[name="quantity"]'));
    if (quantityInput) quantityInput.value = String(this.quantity);
    this.querySelectorAll('[data-nv-total]').forEach(el => { el.textContent = price === undefined ? '' : this.money(price); });
    const button = /** @type {HTMLButtonElement|null} */ (this.querySelector('button[type="submit"]'));
    if (button && !this.busy) button.disabled = !variant?.available;
  }

  /** @param {SubmitEvent} event */
  onSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!(form instanceof HTMLFormElement) || this.busy || !form.reportValidity()) return;
    const variant = this.variant;
    if (!variant?.available) return;
    const button = /** @type {HTMLButtonElement|null} */ (form.querySelector('button[type="submit"]'));
    const label = form.querySelector('[data-add-label]');
    const message = /** @type {HTMLElement|null} */ (form.querySelector('[data-nv-error]'));
    const original = label?.innerHTML || '';
    const data = new FormData(form);
    const useLatviaGifts = document.documentElement.lang.split('-')[0] === 'lv' && String(variant.id) === '54832048472397';
    const merchandiseId = variant.id;
    const quantity = this.quantity;
    data.set('id', String(merchandiseId));
    data.set('quantity', String(quantity));
    data.delete('purchase_type');
    data.delete('selling_plan');
    data.set('sections', 'cart-drawer-section');
    data.set('sections_url', location.pathname);
    const root = Theme.routes.cart_url.replace(/cart\/?$/, '');
    const base = root.endsWith('/') ? root : root + '/';
    this.busy = true;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = nvText('p_5b89f9861bc3');
    if (message) { message.hidden = true; message.replaceChildren(); }
    const pending = CartLinesUpdateEvent.createPromise();
    // Pause the preserved expiry controller without opening the drawer before the add succeeds.
    pending.promise.catch(() => {});
    document.dispatchEvent(new CustomEvent('nuvia:cart-request', { detail: { promise: pending.promise } }));
    let accepted = false;
    try {
      let result;
      if (useLatviaGifts) {
        if (nvReferenceBusy) throw new Error('Cart update in progress');
        nvReferenceBusy = true;
        try {
          const before = await nvReadCart(base);
          const oilCount = nvVariantQuantity(before, 54832048472397) + quantity;
          const items = [];
          for (const [id, threshold] of [[54911369806157, 5], [54911287722317, 3]]) {
            if (oilCount >= threshold && !nvVariantQuantity(before, id)) items.push({ id, quantity: 1, properties: { _nuvia_lv_gift: '1' } });
          }
          if (items.length) {
            const giftResponse = await fetch(base + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items }), headers: { Accept: 'application/json', 'Content-Type': 'application/json' } });
            if (!giftResponse.ok) throw new Error('Gift add failed');
          }
          result = await nvSetOilQuantity(base, oilCount);
        } finally {
          nvReferenceBusy = false;
        }
      } else {
        const response = await fetch(base + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        result = await response.json();
        if (!response.ok || result.status >= 400 || result.errors) throw new Error('add failed');
      }
      accepted = true;
      const cartResponse = await fetch(base + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('refresh failed');
      const cart = await cartResponse.json();
      const update = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: result.sections, source: 'nuvia', didError: false, itemCount: cart.item_count } };
      pending.resolve(update);
      form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(merchandiseId), quantity }], promise: Promise.resolve(update) }));
      if (!document.getElementById('cart-drawer')) location.assign(base + 'cart');
    } catch (error) {
      pending.reject(error instanceof Error ? error : new Error('Cart request failed'));
      if (message) {
        message.hidden = false;
        message.textContent = accepted ? nvText('p_ca85323456f2') : nvText('p_ebe014f597b0');
        const link = document.createElement('a');
        link.href = base + 'cart'; link.textContent = nvText('p_b221e72b1350'); link.style.textDecoration = 'underline';
        message.append(link);
      }
    } finally {
      this.busy = false;
      if (label) label.innerHTML = original;
      button?.removeAttribute('aria-busy');
      this.updatePrice();
    }
  };
}

class NuviaGallery extends HTMLElement {
  controller = new AbortController();
  /** @type {{x:number,y:number}|null} */
  swipeStart = null;
  connectedCallback() {
    this.controller.abort(); this.controller = new AbortController();
    this.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target.closest('[data-nv-thumb]') : null;
      if (target instanceof HTMLElement) this.select(Number(target.dataset.nvThumb));
    }, { signal: this.controller.signal });
    this.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const buttons = [...this.querySelectorAll('[data-nv-thumb]')];
      const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      const next = (current + (event.key === 'ArrowRight' ? 1 : -1) * (document.documentElement.dir === 'rtl' ? -1 : 1) + buttons.length) % buttons.length;
      event.preventDefault(); this.select(next);
      if (buttons[next] instanceof HTMLElement) buttons[next].focus();
    }, { signal: this.controller.signal });
    this.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' && event.target instanceof Element && event.target.closest('.nv-gallery-stage')) this.swipeStart = { x: event.clientX, y: event.clientY };
    }, { signal: this.controller.signal });
    this.addEventListener('pointerup', event => {
      if (!this.swipeStart) return;
      const dx = event.clientX - this.swipeStart.x, dy = event.clientY - this.swipeStart.y;
      this.swipeStart = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      const buttons = [...this.querySelectorAll('[data-nv-thumb]')];
      const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      if (buttons.length) this.select((current + (dx < 0 ? 1 : -1) * (document.documentElement.dir === 'rtl' ? -1 : 1) + buttons.length) % buttons.length);
    }, { signal: this.controller.signal });
    this.addEventListener('pointercancel', () => { this.swipeStart = null; }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller.abort(); }
  /** @param {number} index */
  select(index) {
    const slides = [...this.querySelectorAll('[data-nv-slide]')];
    if (!Number.isInteger(index) || !slides[index]) return;
    slides.forEach((slide, i) => { if (slide instanceof HTMLElement) slide.hidden = i !== index; });
    this.querySelectorAll('[data-nv-thumb]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    const thumb = this.querySelectorAll('[data-nv-thumb]')[index];
    const track = this.querySelector('.nv-gallery-thumbs');
    if (thumb instanceof HTMLElement && track instanceof HTMLElement) {
      const buttonRect = thumb.getBoundingClientRect(), trackRect = track.getBoundingClientRect();
      if (buttonRect.left < trackRect.left || buttonRect.right > trackRect.right) {
        track.scrollBy({ left: buttonRect.left - trackRect.left - (track.clientWidth - thumb.clientWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
  }
}

class NuviaCarousel extends HTMLElement {
  controller = new AbortController();
  connectedCallback() {
    this.controller.abort(); this.controller = new AbortController();
    this.addEventListener('click', event => {
      const button = event.target instanceof Element ? event.target.closest('[data-nv-prev],[data-nv-next]') : null;
      const track = this.querySelector('[data-nv-track]');
      if (!button || !(track instanceof HTMLElement)) return;
      const direction = button.hasAttribute('data-nv-next') ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * direction * (document.documentElement.dir === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller.abort(); }
}

class NuviaSticky extends HTMLElement {
  /** @type {IntersectionObserver|undefined} */
  observer;
  connectedCallback() {
    this.observer?.disconnect();
    const buy = document.querySelector('#custom_buy_box');
    if (!buy) return;
    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry) this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { rootMargin: '-70px 0px 0px 0px' });
    this.observer.observe(buy);
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}

if (!customElements.get('nuvia-buy-box')) customElements.define('nuvia-buy-box', NuviaBuyBox);
if (!customElements.get('nuvia-gallery')) customElements.define('nuvia-gallery', NuviaGallery);
if (!customElements.get('nuvia-carousel')) customElements.define('nuvia-carousel', NuviaCarousel);
if (!customElements.get('nuvia-sticky')) customElements.define('nuvia-sticky', NuviaSticky);

// Included with nuvia-product.js: only extra copies are standalone paid cart lines.
let nvGiftUpdating = false;
class NuviaGiftQuantity extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound) return;
    this.dataset.bound = 'true';
    this.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target.closest('button[data-step]') : null;
      if (!(target instanceof HTMLButtonElement) || target.disabled || nvGiftUpdating) return;
      event.preventDefault();
      const variant = Number(this.dataset.variant);
      const parent = String(this.dataset.parent);
      const step = Number(target.dataset.step);
      if (![54911287722317, 54911369806157].includes(variant) || ![1, -1].includes(step)) return;
      nvGiftUpdating = true;
      const drawer = this.closest('#cart-drawer');
      const errorBox = drawer?.querySelector('.nv-gift-error');
      if (errorBox instanceof HTMLElement) errorBox.hidden = true;
      const controls = [...(drawer?.querySelectorAll('button, input') || [])];
      const enabledControls = controls.filter(el => (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) && !el.disabled);
      enabledControls.forEach(el => el.setAttribute('disabled', ''));
      this.setAttribute('aria-busy', 'true');
      const pending = CartLinesUpdateEvent.createPromise();
      pending.promise.catch(() => {});
      document.dispatchEvent(new CustomEvent('nuvia:cart-request', { detail: { promise: pending.promise } }));
      let accepted = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const beforeResponse = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!beforeResponse.ok) throw new Error('Cart unavailable');
        const before = await beforeResponse.json();
        if (!before.items.some(item => String(item.variant_id) === parent)) throw new Error('Pack unavailable');
        const extra = before.items.find(item => item.variant_id === variant && item.properties?._nuvia_gift_extra === parent);
        const quantity = Math.max(0, (extra?.quantity || 0) + step);
        if (!extra && quantity === 0) { pending.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(before), detail: { source: 'nuvia', didError: false, itemCount: before.item_count } }); return; }
        const body = extra
          ? { id: extra.key, quantity, sections: 'cart-drawer-section', sections_url: location.pathname }
          : { items: [{ id: variant, quantity, properties: { _nuvia_gift_extra: parent } }], sections: 'cart-drawer-section', sections_url: location.pathname };
        const response = await fetch(root + (extra ? 'cart/change.js' : 'cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400 || result.errors) throw new Error('Cart update failed');
        accepted = true;
        const cartResponse = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok || !result.sections?.['cart-drawer-section']) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        const update = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: result.sections, source: 'nuvia', didError: false, itemCount: cart.item_count } };
        pending.resolve(update);
        document.dispatchEvent(new CartLinesUpdateEvent({ action: extra ? 'update' : 'add', context: 'cart', lines: [{ merchandiseId: String(variant), quantity }], promise: Promise.resolve(update) }));
      } catch (error) {
        pending.reject(error instanceof Error ? error : new Error('Cart update failed'));
        if (accepted) { location.reload(); return; }
        if (errorBox instanceof HTMLElement) {
          errorBox.hidden = false;
          errorBox.textContent = 'Neizdevās mainīt daudzumu. Lūdzu, mēģiniet vēlreiz.';
        }
      } finally {
        nvGiftUpdating = false;
        enabledControls.forEach(el => el.removeAttribute('disabled'));
        this.removeAttribute('aria-busy');
      }
    });
  }
}
if (!customElements.get('nv-gift-quantity')) customElements.define('nv-gift-quantity', NuviaGiftQuantity);

// Real gift lines are priced by the Latvian Shopify Function, including paid extra copies.
function nvVariantQuantity(cart, id) {
  return cart.items.filter(item => Number(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
}
async function nvReadCart(base) {
  const response = await fetch(base + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart unavailable');
  return response.json();
}
let nvReferenceBusy = false;
class NuviaReferenceQuantity extends HTMLElement {
  connectedCallback() {
    this.onclick = event => {
      const button = event.target instanceof Element ? event.target.closest('button[data-change]') : null;
      if (!(button instanceof HTMLButtonElement)) return;
      event.preventDefault();
      const current = Number(this.dataset.quantity) || 0;
      const next = button.dataset.change === 'remove' ? 0 : Math.max(0, current + Number(button.dataset.change));
      this.change(next);
    };
  }
  async change(quantity) {
    if (nvReferenceBusy) return;
    nvReferenceBusy = true;
    const base = window.Shopify?.routes?.root || '/';
    const pending = CartLinesUpdateEvent.createPromise();
    pending.promise.catch(() => {});
    document.dispatchEvent(new CustomEvent('nuvia:cart-request', { detail: { promise: pending.promise } }));
    this.querySelectorAll('button').forEach(button => { button.disabled = true; });
    const id = Number(this.dataset.variant);
    try {
      let cart = await nvReadCart(base);
      const desired = new Map([[id, quantity]]);
      const additions = [];
      if (id === 54832048472397) {
        for (const [giftId, threshold] of [[54911369806157, 5], [54911287722317, 3]]) {
          const giftLines = cart.items.filter(item => Number(item.variant_id) === giftId);
          const current = nvVariantQuantity(cart, giftId);
          if (quantity >= threshold && !current) additions.push({ id: giftId, quantity: 1, properties: { _nuvia_lv_gift: '1' } });
          if (nvVariantQuantity(cart, 54832048472397) >= threshold && quantity < threshold && giftLines.some(item => item.properties?._nuvia_lv_gift === '1')) desired.set(giftId, Math.max(0, current - 1));
        }
      }
      if (additions.length) {
        const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: additions }) });
        if (!response.ok) throw new Error('Gift add failed');
        cart = await nvReadCart(base);
      }
      if (id === 54832048472397 && document.documentElement.lang.split('-')[0] === 'lv') {
        await nvSetOilQuantity(base, quantity);
        desired.delete(id);
        cart = await nvReadCart(base);
      }
      const updates = {};
      desired.forEach((count, variantId) => {
        const lines = cart.items.filter(item => Number(item.variant_id) === variantId);
        lines.forEach((line, index) => { updates[line.key] = index === 0 ? count : 0; });
      });
      const response = await fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, sections: 'cart-drawer-section', sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.errors) throw new Error('Cart update failed');
      const update = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(result), detail: { sections: result.sections, source: 'nuvia', didError: false, itemCount: result.item_count } };
      pending.resolve(update);
      document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ merchandiseId: String(id), quantity }], promise: Promise.resolve(update) }));
      if (!document.getElementById('cart-drawer')) location.reload();
    } catch (error) {
      pending.reject(error);
      let message = this.querySelector('.nv-gift-error');
      if (!message) { message = document.createElement('span'); message.className = 'nv-gift-error'; this.append(message); }
      message.textContent = 'Neizdevās atjaunināt grozu. Lūdzu, mēģiniet vēlreiz.';
    } finally {
      nvReferenceBusy = false;
      this.querySelectorAll('button').forEach(button => { button.disabled = false; });
    }
  }
}
if (!customElements.get('nv-reference-quantity')) customElements.define('nv-reference-quantity', NuviaReferenceQuantity);

function nvOilPlan(quantity) {
  const count = Math.max(0, Math.trunc(Number(quantity) || 0));
  const plan = [];
  let remaining = count;
  for (let index = 0; remaining >= 5; index++, remaining -= 5) {
    plan.push({ slot: '5-' + index, quantity: 5 });
  }
  if (remaining >= 3) {
    plan.push({ slot: '3-0', quantity: 3 });
    remaining -= 3;
  }
  if (remaining) plan.push({ slot: 'unit-0', quantity: remaining });
  return plan;
}
async function nvSetOilQuantity(base, quantity) {
  const plan = nvOilPlan(quantity);
  let cart = await nvReadCart(base);
  const oil = cart.items.filter(item => Number(item.variant_id) === 54832048472397);
  const additions = plan.filter(part => !oil.some(item => item.properties?._nuvia_pack_slot === part.slot)).map(part => ({
    id: 54832048472397,
    quantity: part.quantity,
    properties: { _nuvia_pack_slot: part.slot }
  }));
  if (additions.length) {
    const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: additions }) });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('Oil add failed');
    cart = await nvReadCart(base);
  }
  const desired = new Map(plan.map(part => [part.slot, part.quantity]));
  const used = new Set();
  const updates = {};
  for (const item of cart.items.filter(item => Number(item.variant_id) === 54832048472397)) {
    const slot = item.properties?._nuvia_pack_slot;
    updates[item.key] = desired.has(slot) && !used.has(slot) ? desired.get(slot) : 0;
    used.add(slot);
  }
  const response = await fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, sections: 'cart-drawer-section', sections_url: location.pathname }) });
  const result = await response.json();
  if (!response.ok || result.errors || nvVariantQuantity(result, 54832048472397) !== Math.max(0, Math.trunc(Number(quantity) || 0))) throw new Error('Oil update failed');
  return result;
}
async function nvRepairOilCart() {
  if (document.documentElement.lang.split('-')[0] !== 'lv' || nvReferenceBusy) return;
  nvReferenceBusy = true;
  const base = window.Shopify?.routes?.root || '/';
  try {
    const cart = await nvReadCart(base);
    const quantity = nvVariantQuantity(cart, 54832048472397);
    const plan = nvOilPlan(quantity);
    const oil = cart.items.filter(item => Number(item.variant_id) === 54832048472397);
    if (!quantity || (oil.length === plan.length && plan.every(part => oil.some(item => item.properties?._nuvia_pack_slot === part.slot && item.quantity === part.quantity)))) return;
    const pending = CartLinesUpdateEvent.createPromise();
    pending.promise.catch(() => {});
    document.dispatchEvent(new CustomEvent('nuvia:cart-request', { detail: { promise: pending.promise } }));
    try {
      const result = await nvSetOilQuantity(base, quantity);
      const update = { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(result), detail: { sections: result.sections, source: 'nuvia', didError: false, itemCount: result.item_count } };
      pending.resolve(update);
      document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ merchandiseId: '54832048472397', quantity }], promise: Promise.resolve(update) }));
    } catch (error) {
      pending.reject(error);
    }
  } finally {
    nvReferenceBusy = false;
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { nvRepairOilCart().catch(() => {}); }, { once: true });
else nvRepairOilCart().catch(() => {});
